import { useEffect } from 'react';
import { View } from 'react-native';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';

import { cn } from './cn';

export interface ProgressBarProps {
  value: number;
  total: number;
  className?: string;
}

const FILL_DURATION_MS = 250;

/** Thin run-progress bar with a signal-red fill that eases to each new value. */
export function ProgressBar({ value, total, className }: ProgressBarProps) {
  const pct =
    total > 0 ? Math.max(0, Math.min(100, Math.round((value / total) * 100))) : 0;

  // Seed the shared value with the initial pct so the bar doesn't animate from
  // empty on mount; subsequent changes ease to the new width.
  const progress = useSharedValue(pct);
  useEffect(() => {
    progress.value = withTiming(pct, { duration: FILL_DURATION_MS });
  }, [pct, progress]);

  // Width is data-driven, so it lives in an animated style, not a className.
  const fillStyle = useAnimatedStyle(() => ({ width: `${progress.value}%` }));

  return (
    <View className={cn('h-1.5 overflow-hidden rounded-full bg-well', className)}>
      <Animated.View className="h-full rounded-full bg-signal" style={fillStyle} />
    </View>
  );
}
